<template>
    <div id="editorNavContainer">
        <v-app class="navArea">
            <template v-if="loggedIn">
                <v-container fluid>
                    <v-layout align-center>
                    
                        <v-flex xs12 sm4 d-flex>
                            <v-select :items="surveyList" label="Edit survey" v-on:change="surveySelect">
                                <template slot="item" slot-scope="data">
                                    <div :class="'item'+data.item">
                                        <v-icon v-if="data.item == 'New survey'">add</v-icon>
                                        {{ data.item }}
                                    </div>
                                </template>
                            </v-select>
                        </v-flex>
                        <v-flex xs12 sm8 d-flex>
                            <div class="logoutContainer">
                                <div class="userButton" @click="logout">
                                    
                                    <div class="userLabel">
                                        {{profile.name}}
                                    </div>
                                    <div class="iconContainer">
                                        <v-icon>close</v-icon>
                                    </div>
                                </div>
                            </div>
                        </v-flex>
                        
                    </v-layout>
                </v-container>
            </template>
            <template v-else>
                <v-container fluid>
                    <v-layout align-center wrap>
                        <v-flex xs12 sm4 offset-sm4 d-flex class="loginMessage">
                            Here to edit?<br>Let’s get you logged&nbsp;in.
                        </v-flex>
                        <v-flex xs12 sm4 offset-sm4 d-flex>
                            <form>
                                <v-text-field
                                    v-validate="'required|email'"
                                    v-model="email"
                                    :error-messages="errors.collect('email')"
                                    label="E-mail"
                                    data-vv-name="email"
                                    required
                                ></v-text-field>
                                <v-text-field
                                    v-validate="'required'"
                                    v-model="password"
                                    :error-messages="errors.collect('password')"
                                    label="Password"
                                    data-vv-name="password"
                                    required
                                ></v-text-field>
                                <v-btn class="loginBtn" @click="submit">submit</v-btn>
                            </form>
                        </v-flex>
                    </v-layout>
                </v-container>
            </template>
        </v-app>
    </div>
</template>

<script>
import auth from '@/auth'

export default {
    name: 'EditorNav',
    props: ['value', 'content'],
    data() {
        return {
            selected: '',
            surveyList: [],
            loggedIn: false,
            email: "",
            password: "",
            name: ""
        }
    },

    components: {
    },

    methods: {
        surveySelect(val) {
            this.selected = val
            this.$emit('input', this.selected)
        },
        logout() {
            auth.adminSignout()
        },
        remindPassword() {
            console.log('Trigger password reminder')
        },
        submit() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    auth.loginWithEmailPassword(this.email, this.password).then((res) => {
                        console.log("AUTH'D IN");
                    }).catch((err) => {
                        this.error = err.message
                    })
                } else {
                    console.log("ERROR");
                }
            })
        }
    },

    computed: {
    },

    watch: {
        content(val) {
            if (!val) return
            this.surveyList = val.surveyList
            this.loggedIn = val.loggedIn
            console.log("GOT LIST: "+this.loggedIn);
        }
    },

    created() {
    },

    destroyed() {
    },

    mounted() {
        if (!this.content) return
        this.surveyList = this.content.surveyList
        this.loggedIn = this.content.loggedIn
    }
}
</script>

<style lang="scss" scoped>
@import "../styles/variables.scss";
#editorNavContainer /deep/ {
    @import '../styles/vuetify.min';

    .navArea {
        .loginMessage {
            font-weight: bold;
            padding: 20px 0;
        }
        font-weight: 400;
        color: $color-dark;
        height: 120px;
        position: relative;
        font-size: 16px;
        padding-top: 10px;
        .addButton {
            top: 36px;
        }
        .user {
            text-align: right;
            margin-right: 40px;
        }
        .v-label {
            font-weight: 500;
        }
        .v-select__selections {
            font-weight: 400;
            color: $color-dark;
        }
        .v-select-list .itemNew {
            color: $color-darkBeige;
            i {
                color: $color-darkBeige;
                font-size: 20px;
                margin-left: -4px;
            }
        }
        .container.fluid {
            width: 100%;
        }
        .loginBtn {
            margin-left: 0;
        }
        .primary--text {
            color: #1ab394 !important;
            caret-color: #1ab394 !important;
        }
    }
    .userButton {
        cursor: pointer;
        margin-top: -6px;
        float: right;
        position: relative;
        .userLabel {
            display: inline-block;
            color: $color-darkBeige;
            font-size: 16px;
            margin-right: 8px;
            margin-top: 3px;
        }
        .iconContainer {
            float: right;
            display: block;
            padding-top: 5px;
            .v-icon {
                color: $color-darkBeige;
                margin-top: -10px;
            }
        }
    }
}
</style>